import { ApiResult } from 'interfaces/APITypes';

import { buildAxiosResult } from 'utils/axios';

import { mytoverInstance } from './client';

export interface TrialRequestPayload {
  app: string;
  name: string;
  email: string;
  token: string;
}

export const requestTrial = async (serial: string, payload: TrialRequestPayload): Promise<ApiResult> => {
  const response = await mytoverInstance.post(`/units/${serial}/trial`, payload, {
    validateStatus: (status) => status < 500,
  });
  return buildAxiosResult(response);
};

export const checkTrialEligible = async (serial: string, token: string, app: string): Promise<ApiResult> => {
  const response = await mytoverInstance.get(`/units/${serial}/trial_eligible`, {
    // Never throw on an HTTP status — we read the error body (e.g. service_unavailable) ourselves.
    validateStatus: () => true,
    params: { token, app },
  });
  return buildAxiosResult(response);
};

export interface PartnerContactPayload {
  name: string;
  email: string;
  message: string;
  token: string;
}

export const sendPartnerContact = async (serial: string, payload: PartnerContactPayload): Promise<ApiResult> => {
  const response = await mytoverInstance.post(`/units/${serial}/contact`, payload, {
    // Never throw on an HTTP status — we read the error body (e.g. service_unavailable) ourselves.
    validateStatus: () => true,
  });
  return buildAxiosResult(response);
};
